<template>
  <div>
    <van-sticky>
      <van-nav-bar :border="false">
        <template #left><span class="iconfont icon-houtui fs-24 fw-700" @click="$router.back()"></span></template>
        <template #title> <strong class="fs-18">未成年人注册</strong> </template>
      </van-nav-bar>
    </van-sticky>
    <div class="form">
      <div class="form-item">
        <div class="label">用户类型</div>
        <div class="select" :class="{ 'active': cp_type && true || false }" @click="openSelect('cp_type')">
          <span v-if="!cp_type">请选择用户类型</span>
          <span v-else>{{ cp_type }}</span>
          <i class="iconfont icon-jiantou-xia"></i>
        </div>
      </div>
      <div v-show="cp_type === '乐队/组合'" class="form-item">
        <div class="label">乐队关系类型</div>
        <div class="select" :class="{ 'active': team_role && true || false }" @click="openSelect('team_role')">
          <span v-if="!team_role">请选择乐队关系类型</span>
          <span v-else>{{ team_role }}</span>
          <i class="iconfont icon-jiantou-xia"></i>
        </div>
      </div>
      <div class="form-item">
        <div class="label">艺名/乐队名</div>
        <div class="input"><input v-model="nickname" type="text" maxlength="20" placeholder="请输入您的艺名或者乐队名" ></div>
      </div>
      <div class="form-item">
        <div class="label">手机号</div>
        <div class="input"><input ref="mobile" v-model="mobile" type="number" placeholder="手机号码（系统登录使用，请认真填写）" @input="limitNum($refs.mobile, 'mobile', 11)"></div>
      </div>
      <div class="form-item">
        <div class="label">验证码</div>
        <div class="input">
          <input v-model="code" type="text" maxlength="6" placeholder="请输入短信验证码" >
          <div v-if="count === 60" class="code" :class="{ 'active': isSendSms }" @click="isSendSms ? sendSms() : null">发送验证码</div>
          <div v-else class="code">{{ count }}s 重新发送</div>
        </div>
      </div>
      <div class="form-item">
        <div class="label">真实姓名</div>
        <div class="input"><input v-model="realname" type="text" placeholder="请输入您的真实姓名"></div>
      </div>
      <div class="form-item">
        <div class="label">未成年人身份证号</div>
        <div class="input"><input v-model="cardNumber" type="text" maxlength="18" placeholder="请输入您的身份证号"></div>
      </div>
      <div class="form-item">
        <div class="label">密码</div>
        <div class="input">
          <input v-model="password" :type="!showPwd ? 'password' : 'text'" maxlength="20" placeholder="请输入8-20位密码，字母/数字/符号至少2种" >
          <van-icon :name="!showPwd ? 'closed-eye' : 'eye-o'" class="fs-24" @click="showPwd = !showPwd" />
        </div>
      </div>
      <div>
        <van-button :loading="loading" color="#FC3159" class="login-btn mt-24 border-radius" :disabled="!isFinished" loading-text="加载中..." @click="register18">注册</van-button>
        <div class="flex align-center mt-15"><van-checkbox v-model="checked" shape="square" class="mr-8"></van-checkbox>同意 <router-link tag="span" to="/help/detail?id=62&title=平台协议" class="color-0079FF">《用户协议》</router-link>及<router-link tag="span" to="/help/detail?id=62&title=平台协议" class="color-0079FF">《隐私政策》</router-link></div>
      </div>
    </div>

    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
  </div>
</template>

<script>
import { register18 } from '@/api/register.js'
import { smsSend } from '@/api/common.js'
import { validPassword } from '@/utils/validate'
import LimitNum from '@/mixins/number-limit.js'
import { mapState } from 'vuex'
import md5 from 'js-md5'
export default {
  name: 'ChildrenReg',
  mixins: [LimitNum],
  data() {
    return {
      loading: false, // 按钮loading
      show: false,
      showPwd: false, // 默认是密文
      timer: null, // 倒计时ID
      count: 60, // 倒计时时间
      curKey: '', // 当前select的字段
      cp_type: '',
      nickname: '', // 艺名/乐队名/公司简称
      realname: '', // 真实姓名
      cardNumber: '', // 身份证号
      mobile: '',
      password: '',
      code: '',
      team_role: '',
      checked: false, // 是否同意协议
      actions: []
    }
  },
  computed: {
    isSendSms() {
      return this.mobile.length  === 11
    },
    cpTypeOption() {
      return [{ name: '独立音乐人', color: this.cp_type === '独立音乐人' && '#0079FF' || '' }, { name: '乐队/组合', color: this.cp_type === '乐队/组合' && '#0079FF' || '' }]
    },
    teamRoleOption() {
      return [{ name: '主唱', color: this.team_role === '主唱' && '#0079FF' || '' }, { name: '乐手', color: this.team_role === '乐手' && '#0079FF' || '' }, { name: '实际运营管理者', color: this.team_role === '实际运营管理者' && '#0079FF' || '' }]
    },
    isFinished() {
      const { mobile, password, code, cp_type, nickname, team_role, realname, cardNumber, checked } = this
      let isFinished = mobile && password && code && cp_type && nickname && realname && cardNumber && checked
      if (this.cp_type === '乐队/组合') {
        isFinished = isFinished && team_role
      }
      return isFinished
    },
    ...mapState(['isPlus'])
  },
  methods: {
    openSelect(type) {
      this.curKey = type
      this.actions = type === 'cp_type' ? this.cpTypeOption : this.teamRoleOption
      this.show = true
    },
    onSelect(evt) {
      this[this.curKey] = evt.name
      this.show = false
    },
    async sendSms() {
      this.countNumAuto()
      try {
        const res = await smsSend({ mobile: this.mobile, event: 'register' })
        if (res.code === 1) {
          this.$toast.success(res.msg)
        }
      } catch(err) {
        clearInterval(this.timer)
        this.count = 60 // 重新赋值
      } finally {
        this.loading = false
      }
    },
    countNumAuto() { // 倒计时
      this.count--;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.count--;
        if (this.count < 1) {
          clearInterval(this.timer);
          this.count = 60;
        }
      }, 1000)
    },
    async register18() {
      const { cp_type, nickname, realname, mobile, code, cardNumber, team_role, password } = this
      if (!validPassword(password)) {
        this.$toast('请输入8-20位密码，字母/数字/符号至少2种')
        return
      }
      const params = {
        cp_type, nickname, realname, mobile, code,
        cert_no: cardNumber,
        cert_type: '身份证',
        team_role: cp_type === '乐队/组合' ? team_role : null,
        password: md5(password),
        agent_uid: this.$route.query.agent_uid || this.$store.state.agent.id, // 代理商ID,
        source: this.$route.query.source || null // 来源
      }
      try {
        this.loading = true
        const res = await register18(params)
        if (res.code === 1) {
          this.$toast.success(res.msg)
          localStorage.clear()
          this.$store.commit('SET_ROLE', 0)
          let url = location.origin
          if (this.isPlus) {
            url += '?_platform=android'
          }
          location.href = url + '#/realidcation'
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/form.scss';
.form{
  margin-top: 0;
  padding-bottom: 10px;
  .form-item{
    .input{
      color: #222;
    }
  }
}
</style>
